import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Label10Font from '../../../../Theme/Fonts/Label10'
import LiveAnimation from '../../../../Animations/LiveAnimation'

type LiveIndicatorProps = {
    hideLiveIndicator?: boolean
    liveInfo?: string
}

const LiveIndicator = ({
    hideLiveIndicator,
    liveInfo,
}: LiveIndicatorProps): ReactElement | null => {
    {
        if (!hideLiveIndicator) {
            return (
                <Grid horizontal noExpand>
                    {liveInfo ? (
                        <Grid paddingX={1} noExpand minWidth={0}>
                            <Label10Font color="ORANGE" numberOfLines={1}>
                                {liveInfo}
                            </Label10Font>
                        </Grid>
                    ) : (
                        <Grid noExpand paddingTop={2}>
                            <LiveAnimation />
                        </Grid>
                    )}
                </Grid>
            )
        }
        return null
    }
}

export default LiveIndicator
